import React from 'react';
import ProjectList from 'src/pages/Project/List';
import ProjectDetail from 'src/pages/Project/Detail';
import ActivityList from 'src/pages/Activity/List';
import ActivityLeads from 'src/pages/Activity/Leads';
import BenefitList from 'src/pages/Benefit';
import DictionaryList from 'src/pages/Dictionary';
import SmsTemplateList from 'src/pages/SmsTemplate';
import NewsList from 'src/pages/News';
import HomepageConfig from 'src/pages/Homepage';
import BannerList from 'src/pages/Banner';
import BottomMenuList from 'src/pages/BottomMenu';
// import Monitor from 'src/pages/Monitor/List';
import Analysis from 'src/pages/Analysis'
import Layout from 'src/pages/Layout';
import Login from 'src/pages/Login';
import Goods from 'src/pages/Goods';


export const childrenRouter = [
  {
    index: true,
    name: '活动管理',
    path: '/activity',
    exact: true,
    element: <ActivityList />,
  },
  {
    index: true,
    name: '活动线索',
    path: '/activity/leads/:code',
    element: <ActivityLeads />,
  },
  {
    index: true,
    name: '项目',
    path: '/project',
    exact: true,
    element: <ProjectList />,
  },
  {
    index: true,
    name: '项目详情',
    path: '/project/:id',
    element: <ProjectDetail />,
  },
  {
    index: true,
    name: '日历',
    path: '/project/:id/:type',
    element: <ProjectDetail />,
  },
  {
    index: true,
    name: '权益管理',
    path: '/benefit',
    exact: true,
    element: <BenefitList />,
  },
  {
    index: true,
    name: '字典管理',
    path: '/dictionary',
    exact: true,
    element: <DictionaryList />,
  },
  {
    index: true,
    name: '资讯管理',
    path: '/news',
    exact: true,
    element: <NewsList />,
  },
  {
    index: true,
    name: '首页管理',
    path: '/homepage',
    exact: true,
    element: <HomepageConfig />,
  },
  {
    index: true,
    name: '轮播图管理',
    path: '/banner',
    exact: true,
    element: <BannerList />,
  },
  {
    index: true,
    name: '底部菜单管理',
    path: '/bottomMenu',
    exact: true,
    element: <BottomMenuList />,
  },
  {
    index: true,
    name: '短信模板管理',
    path: '/smsTemplate',
    exact: true,
    element: <SmsTemplateList />,
  },
  {
    index: true,
    name: '线索推送报表',
    path: '/media/report',
    element: <Analysis />,
  },
  
  // {
  //   index: true,
  //   name: '监测告警',
  //   path: '/monitor',
  //   exact: true,
  //   element: <Monitor />
  // },

];

export default [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, exact: true, element: <ProjectList /> },
      ...childrenRouter,
    ],
  },
  {
    index: true,
    name: '项目',
    path: '/login',
    exact: true,
    element: <Login />,
  },
  {
    index: true,
    name: '权益录入',
    path: '/good/lead',
    element: <Goods />,
  },
];